// src/data/mockTasks.ts
import { Task } from '../types';

export const mockTasks: Task[] = [
  {
    id: 't1',
    title: 'Subir reglamento interno actualizado',
    description: 'Cliente debe cargar la versión actualizada del reglamento interno de trabajo',
    clientId: 'c1',
    projectId: 'p5',
    assignedTo: 'u2',
    dueDate: '2025-11-10T23:59:59Z',
    status: 'pending',
    priority: 'high',
    createdAt: '2025-11-01T10:00:00Z',
    createdBy: 'u1',
  },
  {
    id: 't2',
    title: 'Revisar hallazgos de auditoría Q4',
    description: 'Revisar y aprobar los hallazgos encontrados en la auditoría del cuarto trimestre',
    clientId: 'c1',
    projectId: 'p1',
    assignedTo: 'u1',
    dueDate: '2025-11-08T17:00:00Z',
    status: 'in-progress',
    priority: 'high',
    createdAt: '2025-10-28T09:00:00Z',
    createdBy: 'u1',
  },
  {
    id: 't3',
    title: 'Completar checklist de SG-SST',
    description: 'Completar todos los ítems pendientes del checklist de seguridad y salud',
    clientId: 'c2',
    projectId: 'p2',
    assignedTo: 'u3',
    dueDate: '2025-11-15T23:59:59Z',
    status: 'pending',
    priority: 'medium',
    createdAt: '2025-11-02T14:00:00Z',
    createdBy: 'u1',
  },
  {
    id: 't4',
    title: 'Enviar informe mensual de RRHH',
    description: 'Preparar y enviar el informe mensual de recursos humanos',
    assignedTo: 'u4',
    dueDate: '2025-11-30T23:59:59Z',
    status: 'pending',
    priority: 'low',
    createdAt: '2025-11-01T08:00:00Z',
    createdBy: 'u1',
  },
  {
    id: 't5',
    title: 'Actualizar documentación de procesos',
    description: 'Revisar y actualizar la documentación de procesos internos',
    clientId: 'c1',
    assignedTo: 'u2',
    dueDate: '2025-11-20T23:59:59Z',
    status: 'in-progress',
    priority: 'medium',
    createdAt: '2025-10-25T11:00:00Z',
    createdBy: 'u1',
  },
  {
    id: 't6',
    title: 'Capacitación completada',
    description: 'Capacitación en liderazgo para mandos medios finalizada exitosamente',
    clientId: 'c2',
    projectId: 'p4',
    assignedTo: 'u3',
    dueDate: '2025-10-31T23:59:59Z',
    status: 'completed',
    priority: 'medium',
    createdAt: '2025-10-01T09:00:00Z',
    createdBy: 'u1',
  },
  {
    id: 't7',
    title: 'Validar contratos laborales',
    description: 'Revisar y validar que todos los contratos estén al día',
    clientId: 'c1',
    assignedTo: 'u2',
    dueDate: '2025-11-12T23:59:59Z',
    status: 'pending',
    priority: 'high',
    createdAt: '2025-11-03T10:30:00Z',
    createdBy: 'u1',
  },
];
